'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('../../_virtual/_tslib.js');
var jsxRuntime = require('react/jsx-runtime');
var React = require('react');

var SvgFunnel = function (props, ref) { return (jsxRuntime.jsx("svg", _tslib.__assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref }, props, { children: jsxRuntime.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.25 2.25C2.25 1.83579 2.58579 1.5 3 1.5H21C21.4142 1.5 21.75 1.83579 21.75 2.25V5.25C21.75 5.43496 21.6816 5.61339 21.558 5.751L15 13.038V20.25C14.9998 20.5727 14.7931 20.859 14.487 20.961L9.987 22.461C9.7584 22.5371 9.50713 22.4988 9.31163 22.358C9.11612 22.2171 9.00018 21.9909 9 21.75V13.038L2.442 5.751C2.31841 5.61339 2.25003 5.43496 2.25 5.25V2.25ZM3.75 3V4.962L10.308 12.249C10.4316 12.3866 10.5 12.565 10.5 12.75V20.709L13.5 19.71V12.75C13.5 12.565 13.5684 12.3866 13.692 12.249L20.25 4.962V3H3.75Z", fill: "currentColor" }) }))); };
var ForwardRef = React.forwardRef(SvgFunnel);

exports["default"] = ForwardRef;
//# sourceMappingURL=Funnel.js.map
